import { render } from "./ContentEditorPage.vue?vue&type=template&id=2c117fc4&scoped=true&ts=true"
import script from "./ContentEditorPage.vue?vue&type=script&lang=ts"
export * from "./ContentEditorPage.vue?vue&type=script&lang=ts"

import "./ContentEditorPage.vue?vue&type=style&index=0&id=2c117fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c117fc4"]])

export default __exports__